import { Injectable, Signal, signal, WritableSignal } from '@angular/core';

export type UnitSystem = 'metric' | 'imperial';

@Injectable({
  providedIn: 'root',
})
export class UnitService {
  private _unit: WritableSignal<UnitSystem> = signal<UnitSystem>('metric');
  public readonly unit: Signal<UnitSystem> = this._unit.asReadonly();

  setUnit(unit: UnitSystem): void {
    this._unit.set(unit);
  }

  initFromQueryParam(unitParam: string | null): void {
    if (unitParam === 'imperial' || unitParam === 'metric') {
      this.setUnit(unitParam);
    }
  }
}
